export default "__VITE_ASSET__Cj$F9za6__"